import { PrescriptionPadStep } from '@/components/Patient/components/PrescriptionPad/PrescriptionPad.types';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const advancePrescriptionPadStep: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  () => PrescriptionPadStep | null
> = (_set, get) => () => {
  const {
    prescriptionPad: { step, showCancellation },
    prescriptionHistory: { itemsToCancel },
  } = get().prescriptionAssistant;
  const shouldShowCancelModal = itemsToCancel.length > 0 && !showCancellation;

  if (step === PrescriptionPadStep.Create) {
    if (shouldShowCancelModal) {
      get().updateShowCancellation(true);
      return PrescriptionPadStep.Create;
    }

    get().updatePrescriptionPadStep(PrescriptionPadStep.Confirm);
    return PrescriptionPadStep.Confirm;
  }

  return null;
};
